import styled from "styled-components";
import { device } from "../device";

export const FeaturedPostContainer = styled.div`
    flex-basis: 100%;
    height: 100%;
    cursor: pointer;

    a, .inner-link-wrapper {
      flex-direction: row;
      width: 100%;
      height: 100%;
      text-decoration: none;

      background-color: #fff;
      display: flex;
      border-radius: 16px;
      overflow: hidden;
      z-index: 0;
      position: relative;

      &:hover {
          .tile-media::after {
              background: rgba(0,0,0,0.15);
          }

          img {
              transform: scale(1.03);
          }
      } 
    }
`;

export const FeaturedTileMedia = styled.div`
    width: 100%;
    height: auto;
    min-height: 362px;
    flex-shrink: 1;
    direction: ltr;
    position: relative;
    z-index: 0;
    flex-grow: 0;
    flex-shrink: 0;
    overflow: hidden;

    &::after {
      content: '';
      display: inline-block;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      -webkit-transition: background 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms;
      transition: background 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms;
    }

    img {
        transition: opacity 1s cubic-bezier(0.4, 0, 0.25, 1) 0ms,transform 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms,-webkit-transform 400ms cubic-bezier(0.4, 0, 0.25, 1) 0ms;
        object-fit: cover;
    }
`;

export const FeaturedTileText = styled.div`
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 0;

    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 250%;
      z-index: 0;
      background: -webkit-gradient(linear, left bottom, left top, from(rgba(0,0,0,0.8)), color-stop(12.83%, rgba(0,0,0,0.77311)), color-stop(24%, rgba(0,0,0,0.72685)), color-stop(33.77%, rgba(0,0,0,0.66487)), color-stop(42.37%, rgba(0,0,0,0.59081)), color-stop(50.07%, rgba(0,0,0,0.50831)), color-stop(57.13%, rgba(0,0,0,0.421)), color-stop(63.78%, rgba(0,0,0,0.33252)), color-stop(70.3%, rgba(0,0,0,0.24652)), color-stop(76.92%, rgba(0,0,0,0.16663)), color-stop(83.91%, rgba(0,0,0,0.09648)), color-stop(91.52%, rgba(0,0,0,0.03973)), to(rgba(0,0,0,0)));
      background: linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.77311) 12.83%, rgba(0,0,0,0.72685) 24%, rgba(0,0,0,0.66487) 33.77%, rgba(0,0,0,0.59081) 42.37%, rgba(0,0,0,0.50831) 50.07%, rgba(0,0,0,0.421) 57.13%, rgba(0,0,0,0.33252) 63.78%, rgba(0,0,0,0.24652) 70.3%, rgba(0,0,0,0.16663) 76.92%, rgba(0,0,0,0.09648) 83.91%, rgba(0,0,0,0.03973) 91.52%, rgba(0,0,0,0));
      background-size: 100.1% 100.1%;
    }
`;
export const FeaturedTileContent = styled.div`
    padding: 0 20px 20px;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    flex-grow: 1;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    z-index: 2;
    @media ${device.tablet} {
        padding: 0 36px 36px;
    }
`;
export const FeaturedTileDescriptionHeadline = styled.div`
    font-size: 30px;
    line-height: 36px;
    font-weight: 700;
    display: -webkit-box;
    overflow: hidden;
    color: #fff;
    @media ${device.tablet} {
        font-size: 40px;
        line-height: 50px;
    }
`;
export const FeaturedTileTimestamp = styled.div`
    color: #fff;
    margin-top: 12px;
    font-size: 14px;
    line-height: 1.28577;
    font-weight: 600;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;